import { CrudModelBase, initialCrudModelBaseState } from '@/shared/models/cruds.models'
import { BillableDeliveryNoteResponse } from '@/api/services/billing/common-delivery-note/billing-common-delivery-note.dto'
import { CommonLaboratoryDatasource } from '@/shared/resources/datasources/common/common-laboratory-datasource'
import { billingModalInvoicesCrudGridColumnDefs } from '@/modules/billing-module/components/modal/invoices/crud/components/grid/config/billing-modal-invoices-crud-grid.column-defs'

export type InvoiceModalGridState<R = BillableDeliveryNoteResponse> = CrudModelBase<R, CommonLaboratoryDatasource<R>>
export const initialInvoiceModalGridState =
    (): InvoiceModalGridState => ({
        ...initialCrudModelBaseState(),
        columnsDef: billingModalInvoicesCrudGridColumnDefs(),
        gridUiComponent: 'uicomponent.billing.grid.invoicesCRUDModal'
    })
